import { useState } from "react";

const getInitials = (companyName: string, ticker: string): string => {
  if (companyName && companyName.trim().length >= 2) {
    return companyName.trim().substring(0, 2).toUpperCase();
  }
  return ticker.substring(0, 2).toUpperCase();
};

const generateAvatarColor = (text: string): string => {
  const colors = [
    "#3B82F6", // Blue
    "#10B981", // Emerald
    "#8B5CF6", // Violet
    "#F59E0B", // Amber
    "#EF4444", // Red
    "#06B6D4", // Cyan
    "#84CC16", // Lime
    "#F97316", // Orange
    "#EC4899", // Pink
    "#6B7280", // Gray
  ];

  // Use the text to generate a consistent color index
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
};

const StockAvatar = ({
  stockDetails,
  ticker,
  companyName,
}: {
  stockDetails: { [key: string]: { name: string; logo: string } };
  ticker: string;
  companyName: string;
}) => {
  const [imageError, setImageError] = useState(false);
  const [fallbackError, setFallbackError] = useState(false);

  const logoUrl = stockDetails[ticker]?.logo;
  // Strip .US or other suffixes from ticker for fallback URL
  const baseTicker = ticker.split('.')[0].toLowerCase();
  const fallbackUrl = `https://github.com/davidepalazzo/ticker-logos/blob/main/ticker_icons/${baseTicker}.png?raw=true`;

  console.log(`StockAvatar [${ticker}]:`, { imageError, fallbackError, logoUrl, fallbackUrl });

  // Show initials avatar if:
  // 1. Both primary and fallback failed, OR
  // 2. No primary logo and fallback failed
  const shouldShowInitials = (imageError && fallbackError) || (!logoUrl && fallbackError);

  if (shouldShowInitials) {
    const initials = getInitials(companyName, ticker);
    const backgroundColor = generateAvatarColor(ticker);

    return (
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
        style={{ backgroundColor }}
      >
        {initials}
      </div>
    );
  }

  // Show image avatar with error handling
  return (
    <div className="w-8 h-8 flex-shrink-0">
      <img
        src={!imageError && logoUrl ? logoUrl : fallbackUrl}
        alt={companyName}
        className="w-full h-full rounded-full object-cover bg-gray-100"
        onError={() => {
          if (!imageError && logoUrl) {
            setImageError(true);
          } else {
            setFallbackError(true);
          }
        }}
      />
    </div>
  );
};

export default StockAvatar;
